import { Hospital, HOSPITAIS_SP, calcularDistancia } from './hospitais-sp';
import { HOSPITAIS_MG, HOSPITAIS_RJ } from './hospitais-mg-rj';

export type { Hospital };

export const TODOS_HOSPITAIS: Hospital[] = [
  ...HOSPITAIS_SP,
  ...HOSPITAIS_MG,
  ...HOSPITAIS_RJ,
];

export function hospitaisMaisProximosTodos(
  lat: number,
  lng: number,
  limite = 5
): (Hospital & { distanciaKm: number })[] {
  return TODOS_HOSPITAIS
    .map(h => ({ ...h, distanciaKm: calcularDistancia(lat, lng, h.lat, h.lng) }))
    .sort((a, b) => a.distanciaKm - b.distanciaKm)
    .slice(0, limite);
}

export { calcularDistancia };
export const TOTAL_HOSPITAIS = TODOS_HOSPITAIS.length;
